import { Landmark } from "lucide-react";
import { STATE_BADGES } from "./parts";

// One quota <tr>: member, tier (+monthly badge), amount, state, receipt and actions.
export const QuotaRow = ({ it, onMarkPaid }) => {
  const badge = STATE_BADGES[it.state] || STATE_BADGES.no_tier;
  const BIcon = badge.Icon;
  const canMarkPaid = it.state === "pending" ||
    (it.modality === "monthly" && (it.months_paid || []).length < 12 && it.state !== "no_tier" && it.state !== "exempt");
  return (
    <tr className="border-b border-[hsl(var(--border))] last:border-0 hover:bg-[hsl(var(--secondary))]/40">
      <td className="px-4 py-3 align-top">{it.name || "—"}</td>
      <td className="px-4 py-3 align-top">{it.email}</td>
      <td className="px-4 py-3 align-top text-[hsl(var(--muted-foreground))]">
        {it.tier_label || "—"}
        {it.modality === "monthly" && (
          <span className="ml-1.5 text-[10px] px-1.5 py-0.5 bg-purple-50 text-purple-700 border border-purple-200 rounded-sm align-middle" data-testid={`modality-monthly-${it.member_id}`}>
            Mensal {(it.months_paid || []).length}/12
          </span>
        )}
      </td>
      <td className="px-4 py-3 align-top">{it.amount_eur != null ? `${Number(it.amount_eur).toFixed(2)} €` : "—"}</td>
      <td className="px-4 py-3 align-top">
        <span className={`inline-flex items-center gap-1 px-2 py-1 text-[11px] rounded-sm ${badge.cls}`}>
          <BIcon className="h-3 w-3" /> {badge.label}
        </span>
      </td>
      <td className="px-4 py-3 align-top text-[hsl(var(--muted-foreground))]">
        {it.receipt_number ? `Nº ${String(it.receipt_number).padStart(4, "0")}` : "—"}
      </td>
      <td className="px-4 py-3 text-right align-top">
        {canMarkPaid && (
          <button
            onClick={() => onMarkPaid(it)}
            className="inline-flex items-center gap-1 px-3 py-1.5 border border-[hsl(var(--primary))] text-[hsl(var(--primary))] text-xs uppercase tracking-wide hover:bg-[hsl(var(--primary))] hover:text-white transition-colors"
            data-testid={`mark-paid-transfer-${it.member_id}`}
            title="Marcar como paga via transferência bancária"
          >
            <Landmark className="h-3 w-3" /> Marcar paga (transf.)
          </button>
        )}
      </td>
    </tr>
  );
};
